
import React, { useEffect, useMemo, useState } from 'react';
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Button from '@mui/material/Button';



import { useParams } from 'react-router';
import FormBuilder, { IMedAppFormField } from '../../../../form';
import { useMutation, useQuery } from 'react-query';
import { Physician, WithdrawalRequest } from '../../../../../models';
import api, { ViewRequest } from '../../../../../api/medAppApi';
import { putMessage } from '../../../../app/store/actions';
import { useDispatch } from 'react-redux';
import { titleCase, to2DecimalPlaces } from '../../../../../helpers';
import { reduxForm } from 'redux-form';


const ApproveWithdrawalForm: React.FC<any> = ({ mFields, name, handleSubmit, onSubmit }) => {

    const handleSubmitCallback = (value: any) => {
        onSubmit(value);
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitCallback)}>  <FormBuilder fields={mFields} name={name} />
            <Button type="submit" variant="contained">Continue</Button>
        </form>);
}

const ApproveWithdrawalReduxForm = reduxForm<any, any>({
    form: 'apprve withdrawal-request'
})(ApproveWithdrawalForm);
 

const ApproveWithdrawal: React.FC = () => {
    const dispatch = useDispatch();
    
    const [request, setWithdrawalRequest] = useState<WithdrawalRequest | undefined>();
    let { id } = useParams<{ id: string }>();

    const check = async (modelId: number) => {
       

      const criteria: ViewRequest = {
          modelName: "withdrawalrequest",
          modelId,
          populate: "physician",
        };
    let ans = await api.viewModel<WithdrawalRequest>(criteria);
    return ans;

}
    const {isLoading, data, isFetching, isError} = useQuery('load-withdrawal-request-' + id,  () => check(parseInt(id || '-1', 10)))
    const mtnFn = async (data: {withdrawalRequest: number}) => {
        const resp = await api.approveWithdrawal({}, {}, data);
        if(resp.errorData) {
            throw new Error(resp.errorData.problems || 'Something went wrong');
        } else if(resp.error) {
            throw new Error(resp.error || 'Something went wrong'); 
        }
        return resp;
    }
    const {mutate, isLoading: isApproving} =  useMutation({
        mutationFn: mtnFn,
        mutationKey: 'approve-withdrawal',
        onSuccess: (d) => {
            console.log(d);
            dispatch(putMessage({
                type: 'success',
                message: 'Successfully approved this withdrawal'
            }))
        },
        onError: (error) => {
            dispatch(putMessage({
                type: 'error',
                message: (error as any).message
            }))
        }
    })


    const handleSubmit = () => {
        const data_ = {
            withdrawalRequest: request!.id
        }
        mutate(data_)
        
    }

    useEffect(() => {
      if(isError) {
        dispatch(
          putMessage({
            type: "error",
            message: "Failed to load data",
          })
        );
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isError] )
    useEffect(() => {
      if(data) {
        setWithdrawalRequest(data.data!.data.payload)
      }
    }, [data])
    
    const fields: IMedAppFormField[] =useMemo(() => {
        if(!request) {
            return []
        }
        const physician = request.physician as Physician;
        const name = titleCase(`Dr. ${physician.FirstName} ${physician.LastName}`)

        return [
            {
                name: 'amount',
                label:'Amount NGN' + to2DecimalPlaces( request.amount, true),
                type: 'number',
                defaultValue: request.amount,
                
                inputExtras: {
                    disabled: true,
                    
                }

            }, {
                name: 'user',
                label: name,
                type: 'text',
                inputExtras: {
                    disabled: true,
                }

            },
            {
                name: 'statusReason',
                label: 'Note',
                type: 'text'
            }
        ] as Array<IMedAppFormField>;
    }, [request])



 
        return (
            <Box style={{
                width: '100%'
            }}>
                <Box sx={{
                    width: '70%',
                    maxWidth: '700px',
                    minWidth: '250px',
                    marginLeft: '1em'
                }}>
                    {(isFetching || isApproving || isLoading) && <LinearProgress />}
                    <ApproveWithdrawalReduxForm mFields={fields} namel="kosy" onSubmit={handleSubmit} />
                </Box>
            </Box>
        );
 

    
}

export default ApproveWithdrawal;
